import servers from "@/servers";
import moment from "moment";

/**
 *
 * @param { string } name 文件名称
 * @returns { string } 后缀名
 */
export const getSuffixName = (name: string) => {
  const splits = name.split(".");
  return splits[splits.length - 1];
};

/**
 * 是否渠道网站
 * @returns
 */

export const isChannelDomain = () => {
  const channelDomain = ["qiniu.metamaker.cn"];
  if (channelDomain.includes(document.domain)) {
    return true;
  } else {
    return false;
  }
};

/**
 *
 * @param val 复制的值
 */

export const copy = (val) => {
  const input = document.createElement("input");
  input.value = val;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
};

export const checkEAAccess = (accessField) => {
  if (accessField && accessField[1] == "灰度") {
    localStorage.isEarlyAccess = "true";
  } else {
    localStorage.isEarlyAccess = "false";
  }
  const isEarlyAccess = localStorage.isEarlyAccess == "true";
  const eapass = isEarlyAccess && servers.isEarlyAccessEnabled ? servers.eaAccessUrl : "/";
  const cl = location.origin + eapass;
  if (location.origin + location.pathname !== cl) {
    console.error("redirect to t");
    location.replace(cl);
  }
};

export const getUrlParams = () => {
  const url = location.href;
  return JSON.parse(
    `{"${decodeURI(url.split("?")[1])
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')}"}`
  );
};

/**
 * 格式化时间
 */

export const formatPersonalTime = (timestamp) => {
  moment.locale("zh-cn");
  return moment(timestamp * 1000).fromNow();
};

export const formatTime = (timestamp, format = "YYYY-MM-DD") => {
  moment.locale("zh-cn");
  return moment(timestamp * 1000).format(format);
};

export const getCookie = (key) => {
  const arr1 = document.cookie.split(";");
  for (let i = 0; i < arr1.length; i++) {
    const arr2 = arr1[i].split("=");
    if (key.trim() === arr2[0].trim()) {
      return arr2[1];
    }
  }
  return "";
};

export const parseTimeNum = (num = 0) => {
  return num > 9 ? num : "0" + num;
};

/**
 * 秒数转时间
 */
export const formatSeconds = (value) => {
  let secondTime = parseInt(value), // 秒
    minuteTime = 0, // 分
    hourTime = 0, // 小时
    dayTime = 0; // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = Math.floor(secondTime / 60);
    //获取秒数，秒数取余，得到整数秒数
    secondTime = Math.floor(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = Math.floor(minuteTime / 60);
      //获取小时后取余的分，获取分钟除以60取余的分
      minuteTime = Math.floor(minuteTime % 60);
      //如果小时大于24，将小时转换成天
      if (hourTime > 24) {
        //获取天，获取小时除以24，得到整数天
        dayTime = Math.floor(hourTime / 24);
        //获取天后取余的小时，获取小时除以24取余的小时
        hourTime = Math.floor(hourTime % 24);
      }
    }
  }
  let result = "";
  if (dayTime > 0) {
    result += dayTime + "天 ";
  }
  result +=
    parseTimeNum(hourTime) + ":" + parseTimeNum(minuteTime) + ":" + parseTimeNum(secondTime);

  return result;
};

/**
 * 是否是移动端
 */

export const isMobile = () => {
  return window.navigator.userAgent.indexOf("Mobile") > -1;
};

/**
 * 格式化金额数字
 */
export const numToThousands = (num = 0) => {
  return num.toString().replace(/\d+/, function (n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  });
};

/**
 * 获取当天0点时间戳
 */
export const getTodayStartTime = (dateline = new Date()) => {
  return new Date(new Date(dateline).toLocaleDateString()).getTime();
};

/**
 * 获取当天23:59:59时间戳
 */
export const getTodayEndTime = (dateline = new Date()) => {
  return new Date(new Date(dateline).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
};

/**
 * 获取整点开始时间戳 （例13:58:50 -> 13:00:00）
 */
export const getHourStartTime = (dateline = new Date()) => {
  const now = new Date(dateline);
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth();
  const nowDate = now.getDate();
  const nowHour = now.getHours();
  return new Date(nowYear, nowMonth, nowDate, nowHour).getTime();
};

/**
 * 获取整点结束时间戳 （例13:58:50 -> 13:59:59）
 */
export const getHourEndTime = (dateline = new Date()) => {
  const now = new Date(dateline);
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth();
  const nowDate = now.getDate();
  const nowHour = now.getHours();
  return new Date(nowYear, nowMonth, nowDate, nowHour).getTime() + 60 * 60 * 1000 - 1;
};

/**
 * 获取当周周一0点时间戳
 */
export const getWeekStartTime = (dateline = new Date()) => {
  const now = new Date(dateline);
  const day = now.getDay();
  const n = day == 0 ? 6 : day - 1;
  now.setDate(now.getDate() - n);
  return getTodayStartTime(now);
};

/**
 * 获取当周周日23:59:59时间戳
 */
export const getWeekEndTime = (dateline = new Date()) => {
  const now = new Date(dateline);
  const day = now.getDay();
  const n = day == 0 ? 0 : day - 7;
  now.setDate(now.getDate() - n);
  return getTodayEndTime(now);
};

/**
 * 获取当月第一天0点时间戳
 */
export const getMonthStartTime = (dateline = new Date()) => {
  const now = new Date(dateline);
  const nowMonth = now.getMonth();
  const nowYear = now.getFullYear();
  return new Date(nowYear, nowMonth, 1).getTime();
};

/**
 * 获取当月最后一天23:59:59时间戳
 */
export const getMonthEndTime = (dateline = new Date()) => {
  const now = new Date(dateline);
  now.setMonth(now.getMonth() + 1);
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth();
  return Math.floor(new Date(nowYear, nowMonth, 1).getTime() - 1);
};
